import { BaseApi } from '../baseApi';
import type { OpportunityDetailResponse } from '@/types/models';

export interface ApplicationResponse {
    id: number;
    opportunity: OpportunityDetailResponse;
    student_note?: string;
    cover_letter: string;
    status: 'pending' | 'approved' | 'rejected' | 'withdrawn';
    created_at: string;
    reviewed_at?: string;
    student_profile?: {
        id: number;
        first_name: string;
        last_name: string;
        email: string;
        skills: string[];
    };
}

export interface CreateApplicationRequest {
    opportunity_id: number;
    student_note?: string;
    cover_letter: string;
}

interface ApplicationAPIResponse<T> {
    data: T;
    meta: {
        timestamp: string;
        total?: number;
    };
}

export class ApplicationApi extends BaseApi {
    async getApplications(): Promise<ApplicationResponse[]> {
        const response = await this.makeGet<ApplicationAPIResponse<ApplicationResponse[]>>('/applications');
        return response.data;
    }

    async getApplicationDetail(id: number): Promise<ApplicationResponse> {
        const response = await this.makeGet<ApplicationAPIResponse<ApplicationResponse>>(`/applications/${id}`);
        return response.data;
    }

    async createApplication(data: CreateApplicationRequest): Promise<ApplicationResponse> {
        const response = await this.makePost<ApplicationAPIResponse<ApplicationResponse>>('/applications', data);
        return response.data;
    }

    async updateApplicationStatus(id: number, status: 'approved' | 'rejected'): Promise<ApplicationResponse> {
        const response = await this.makePatch<ApplicationAPIResponse<ApplicationResponse>>(`/applications/${id}/status`, { status });
        return response.data;
    }

    async checkExistingApplication(opportunityId: string): Promise<{ exists: boolean; application?: ApplicationResponse }> {
        const response = await this.makeGet<ApplicationAPIResponse<{ exists: boolean; application?: ApplicationResponse }>>(`/applications/check/${opportunityId}`);
        return response.data;
    }
} 